<template>
  <div class="flex-row ms-group-button">
    <menu-wrapper
      ref="menu"
      :hide-in-content="false"
      :position="{at: 'left bottom', my: 'left top'}"
      class="topnav-widget-more-container"
    >
      <!-- Nút lọc -->
      <template #menu-button="{toggleMenu}">
        <ms-button
          :text="btnText"
          :has-border="true"
          type=""
          :class="{active: active || $refs.menu?.isOpen}"
          :left-icon="active || $refs.menu?.isOpen ? 'icon-group-active' : 'icon-group'"
          @click="
            e => {
              toggleMenuWrapper(toggleMenu, e);
            }
          "
          @mouseenter="active = !active"
          @mouseleave="active = !active"
        />
      </template>
      <template #menu-content="{closeHandler}">
        <div class="menu-container-filter">
          <div class="group-button-title mb-2">
            <label>{{ dropdownLabel }}</label>
          </div>
          <!-- For từng control -->
          <div class="group-list-wrapper flex-column">
            <div v-for="(item, index) in groupLayer" :key="index">
              <div class="title-group mb-1">
                <label class="label" title="">Mức {{ index + 1 }}</label>
              </div>
              <div class="w-350 mb-2">
                <ms-combobox
                  v-model="model[index]"
                  :init-text="display[index]"
                  :data="comboData[index]"
                  value-field="valueField"
                  display-field="displayField"
                  :dropdown-width="350"
                  :rules="[{name: $ms.constant.ValidateRule.ForceSelection}]"
                ></ms-combobox>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-right btn-filter-group">
          <ms-button
            type="outline-button"
            text="Đặt lại"
            class="mr-2 btn-setting max-height"
            @click="deleteAllFilter()"
          />

          <ms-button
            text="Thực hiện"
            class="btn-filter-agree"
            @click.prevent="$emit('update:modelValue', [...model])"
            @click="
              () => {
                $emit(
                  'submit',
                  model?.filter(x => x?.length > 0),
                );
                closeHandler();
              }
            "
          >
          </ms-button>
        </div>
      </template>
    </menu-wrapper>
  </div>
</template>

<script>
import {getCurrentInstance, nextTick, ref} from 'vue';

import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import ControlType from '@/commons/wildcards/constants/ControlType.js';

export default {
  components: {MenuWrapper, MenuItem},
  name: 'MsGroupButton',
  props: {
    /**
     * Text của button
     */
    btnText: {
      default: 'Nhóm dữ liệu',
      type: String,
    },
    dropdownLabel: {
      default: 'Nhóm theo cột',
      type: String,
    },
    /**
     * Dữ liệu cho các combo
     */
    groupData: {
      default: [],
      type: Array,
    },
    /**
     * Số tầng group
     */
    groupLayer: {
      default: 3,
      type: Number,
    },
    /**
     * Model khởi tạo
     */
    initModel: {
      default: [],
      type: Array,
    },
  },
  data() {
    return {
      model: [],
      display: [],
      active: false,
    };
  },
  watch: {
    groupData: {
      handler() {
        for (let i = 0; i < this.groupLayer; i++) {
          this.comboData[i] = this.groupData;
        }
      },
      deep: true,
      immediate: true,
    },
    initModel: {
      handler() {
        this.model = this.initModel ?? [];
      },
      immediate: true,
    },
    model: {
      handler() {
        for (var i = 0; i < this.groupLayer; i++) {
          this.comboData[i] = this.groupData.filter(
            x => !this.model.includes(x.valueField) || x.valueField == this.model[i],
          );

          this.display[i] = this.groupData.filter(x => x.valueField == this.model[i])[0]?.displayField ?? '';
        }
      },
      deep: true,
      immediate: true,
    },
  },

  emits: ['submit', 'update:modelValue', 'update:display'],

  setup(props, {emit}) {
    /** Proxy */
    const {proxy} = getCurrentInstance();
    /** Object lọc bên trong */
    const filter = ref({});
    /** Dữ liệu mặc định */
    const defaultFilter = ref({});
    /**
     * Dữ liệu cho từng combo
     */
    const comboData = ref([]);

    /**
     * Xóa lọc tất cả
     *pthai 26/09/2022
     */
    const deleteAllFilter = () => {
      proxy.model.removeAll();
      proxy.display.removeAll();
    };

    /**
     * Submit form để lọc
     * nvtoan2 18/11/2024
     */
    const submitForm = () => {
      const me = proxy;

      emit('submit', model);

      me.$refs.menu.close();
    };

    /**
     * Xử lý refresh form lọc
     * pthai 26/09/2022
     */
    function toggleMenuWrapper(toogle, e) {
      toogle(e);

      if (proxy.$refs.menu.isOpen) {
        /** Cập nhật vào dữ liệu form */
        // Object.assign(filter.value, props.modelValue, obj);
      }
    }

    return {
      submitForm,
      ControlType,
      filter,
      defaultFilter,
      deleteAllFilter,
      toggleMenuWrapper,
      comboData,
    };
  },
};
</script>

<style lang="scss" scoped>
.outline-button {
  border: 1px solid $black !important;
}

.circle-button {
  border: 2px solid $circle-button !important;
}
.dropdown-body-container {
  padding: 16px 10px 10px 10px;
}
.menu-container-filter {
  padding: 16px 0px;

  .group-button-title {
    padding: 0 16px;
  }

  .group-list-wrapper {
    max-height: 300px;
    overflow: auto;
    padding: 0 16px;
  }

  :deep(.container-period) {
    flex: 1;

    .icon-combo--dropdown {
      border-left: none;
    }
  }

  :deep(.container-date) {
    flex: 2;

    .ms-calendar {
      &::before {
        display: block;
      }
    }
  }

  :deep(.combo-box-input) {
    .icon-combo--dropdown {
      border-left: none;
    }
  }
}

.container-period {
  width: 200px;
}

.filter-group {
  display: flex;
  padding: 0px 20px;

  .filter-item {
    display: flex;
    align-items: center;

    &:not(:first-child) {
      margin-left: 20px;
    }

    &.delete {
      .text {
        color: $blue;
      }
    }
  }
}

.filter-menu-item {
  &:not(:first-child) {
    margin-top: 10px;
  }
}

.btn-filter-group {
  padding: 7px 16px;
  background-color: $secondary-active;

  .btn {
    font-weight: 600;
  }
  .btn-setting {
    background-color: $white;
  }

  .btn-filter-agree {
    background-color: $primary;
    color: $white;
  }
}

.btn-gr {
  &:hover {
    cursor: pointer;
  }
}

:deep(.btn) {
  background-color: transparent;
  .text {
    font-weight: unset !important;
  }
}

:deep(.btn) {
  &.active {
    .text {
      color: $blue-text;
    }
  }
}

.group-button-title {
  font-weight: 800;
  font-size: 18px;
}

.ic-delete {
  margin: 3px 0 0 2px;
}

.misa-link {
  color: $semi-blue;
  align-items: center;
  display: flex;

  &:not([href]):not([tabindex]) {
    color: $semi-blue;

    &:hover {
      cursor: pointer;
      color: $semi-blue;
    }
  }

  &[href] {
    color: $semi-blue;

    &:hover {
      cursor: pointer;
      color: $blue;
    }
  }

  &:hover {
    cursor: pointer;
    color: $blue;
  }
}

.w-350 {
  width: 350px;
}

.flex-right {
  display: flex;
  // để justify-content:right; trên các trình duyệt khác chrome không nhận-htthoa(21/06/2023)-bug 15036
  justify-content: flex-end;
  align-items: center;
}
</style>
